// The Control Center chat bubble (index.html, widget.js) renders in a shadow
// root with no public "open" API -- only `window.ccChat.identify`. Clicking
// the real bubble's own button is the only documented way to open it from
// outside its shadow root. Shared so every in-app nudge (Contact page,
// stalled-setup prompts) opens the same widget the same way.
//
// A real user reported (2026-09-23, /creator/donations) that this link "doesn't
// work when opened from a phone" -- the widget's own mobile layout can leave the
// shadow-DOM bubble absent or unclickable, and every step here is optional
// chaining, so a missed bubble was a silent no-op with no visible fallback.
export function openSupportChat() {
    const bubble = (document.querySelector('[data-cc-chat]') as HTMLElement | null)
        ?.shadowRoot?.querySelector<HTMLButtonElement>('#bubble');
    if (bubble) {
        bubble.click();
    } else {
        window.location.href = '/contact';
    }
}
